import React, { Suspense } from "react";
const LoginPageWrapper = React.lazy(() => import("../components/LoginPageWrapper"));

function LoginPage() {
  return (
    <Suspense
      fallback={
        <>
          Loading...
        </>
      }
    >
      <LoginPageWrapper />
    </Suspense>
  );
}

export default LoginPage;
